import { system } from 'styled-system';
export const objectFitValues = ['contain', 'cover', 'unset'];
export function objectFit() {
    return system({
        objectFit: {
            property: 'objectFit',
            transform: (val) => val !== null && val !== void 0 ? val : 'unset',
        }
    });
}
//# sourceMappingURL=objectFit.js.map